import { Status } from "../../../../components/ui";

// Report 58 (§G): one way to show "does this pay rule apply, and what does payroll do" — used by Settings › Overtime,
// holidays & night pay and by Employee › Pay. The server decides every status and effect (applicability.js); this only
// puts them into words.

export const STATUS_WORD = {
  GENERALLY_APPLICABLE: "Applies",
  ESTABLISHMENT_EXCEPTION: "Small-business exception",
  EMPLOYEE_EXCEPTION: "Employee exception",
  MORE_FAVOURABLE_PRACTICE: "Not required by law · paid by the business",
  FACTS_MISSING: "Business size needed",
  FACTS_CONFLICT: "Confirm the business size again",
  RULE_UNSUPPORTED: "Not checked by Apparify",
};
export const EFFECT_WORD = {
  PAID_AUTOMATICALLY: "Payroll pays it",
  NOT_PAID: "Payroll does not pay it",
  HELD_FOR_REVIEW: "Payroll holds it for a decision",
  PAID_BY_BUSINESS_PRACTICE: "Payroll pays it (the business's own practice)",
  PAID_UNDER_STANDARD_RULES: "Payroll pays it under the standard holiday rules",
};
const WARN = new Set(["FACTS_MISSING", "FACTS_CONFLICT", "RULE_UNSUPPORTED"]);
const KIND = { RETAIL_OR_SERVICE: "Retail or service business", OTHER: "Not a retail or service business" };

/** "Retail or service business · 7 workers confirmed · exception only for fewer than 10 workers" */
export function thresholdLine(establishment) {
  if (!establishment) return null;
  const parts = [KIND[establishment.kind] || null];
  if (establishment.confirmedWorkers != null) parts.push(`${establishment.confirmedWorkers} worker${Number(establishment.confirmedWorkers) === 1 ? "" : "s"} confirmed`);
  if (establishment.kind === "RETAIL_OR_SERVICE" && establishment.thresholdText) parts.push(establishment.thresholdText);
  return parts.filter(Boolean).join(" · ");
}

export default function PayRuleApplicabilityList({ rules = [], className = "" }) {
  return (
    <ul className={`divide-y divide-subtle text-body-sm ${className}`}>
      {rules.map((rule) => (
        <li key={rule.benefit} className="flex flex-col gap-1 py-3 sm:flex-row sm:items-start sm:justify-between sm:gap-6">
          <div className="min-w-0 max-w-[75ch]">
            <p className="font-medium text-foreground">{rule.label}</p>
            {rule.explanation ? <p className="mt-0.5 text-body-sm text-secondary">{rule.explanation}</p> : null}
            {thresholdLine(rule.establishment) ? <p className="mt-1 text-meta text-tertiary">{thresholdLine(rule.establishment)}</p> : null}
            {rule.nextAction ? <p className="mt-1 text-meta text-secondary">Next: {rule.nextAction.label}{rule.nextAction.who === "OWNER" ? " (the owner)" : rule.nextAction.who === "HR" ? " (HR)" : ""}.</p> : null}
          </div>
          <div className="flex shrink-0 flex-col gap-0.5 sm:items-end sm:text-right">
            {WARN.has(rule.status) ? <Status tone="warning" icon>{STATUS_WORD[rule.status]}</Status> : <span className="text-body-sm font-medium text-foreground">{STATUS_WORD[rule.status] || rule.status}</span>}
            <span className="text-meta text-secondary">{EFFECT_WORD[rule.payrollEffect] || ""}</span>
          </div>
        </li>
      ))}
    </ul>
  );
}
